import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
  Checkbox,
  FormControlLabel,
  Paper,
  Typography,
} from '@material-ui/core'
import moment from 'moment'
import { setActiveDateRange } from 'reducers/sensor/reducer'
import messages from '../translate'
import ProdAndHealth from './ProdAndHealth'
import EnvironmentData from './Environment'
import LogbookData from './Logbook'
import DateRangeInput from './DateRange'

class RightSidebar extends Component {
  componentDidUpdate(prevProps) {
    const {
      activeProdAndHealthType,
      activeEnvironmentType,
      switcher,
    } = this.props
    const {
      activeProdAndHealthType: prevActiveProdType,
      activeEnvironmentType: prevActiveEnvType,
    } = prevProps
    const prodValue = activeProdAndHealthType.get('value')
    const envValue = activeEnvironmentType.get('name')
    const disableCombine = Boolean(!prodValue || !envValue)

    if (
      (prodValue !== prevActiveProdType.get('value') ||
        envValue !== prevActiveEnvType.get('name')) &&
      disableCombine
    ) {
      switcher(disableCombine)
    }
  }

  onDateRangeChange = range => {
    if (range) {
      let { startDate, endDate } = range

      if (!moment.isMoment(startDate)) {
        startDate = moment(startDate)
      }

      if (!moment.isMoment(endDate)) {
        endDate = moment(endDate)
      }

      this.props.setActiveDateRange({
        startDate,
        endDate,
      })
    }
  }

  render() {
    const {
      intl: { formatMessage },
      combineCharts,
      switcher,
      activeProdAndHealthType,
      activeEnvironmentType,
    } = this.props
    const prodValue = activeProdAndHealthType.get('value')
    const envValue = activeEnvironmentType.get('name')
    const disableCombineCharts = !prodValue || !envValue

    return (
      <Paper className="db-right-sidebar">
        <div className="db-module-head">
          <Typography className="db-module-title" variant="h6">
            <FormattedMessage {...messages.dataToShow} />
          </Typography>
        </div>
        <div className="db-filter-row">
          <ProdAndHealth />
        </div>
        <div className="db-filter-row">
          <EnvironmentData />
        </div>
        <div className="db-filter-row">
          <LogbookData />
        </div>
        <div className="db-filter-row">
          <DateRangeInput onChange={this.onDateRangeChange} />
        </div>
        <div className="db-filter-row">
          <FormControlLabel
            className="combine-charts"
            label={formatMessage(messages.combineCharts)}
            control={
              <Checkbox
                href={null}
                disableRipple
                disabled={disableCombineCharts}
                checked={combineCharts}
                onChange={() => switcher()}
                color="primary"
              />
            }
          />
        </div>
      </Paper>
    )
  }
}

export default connect(
  state => ({
    activeProdAndHealthType: state.getIn(['dataBrowser', 'activeProductions']),
    activeEnvironmentType: state.getIn(['dataBrowser', 'activeEnvironment']),
    productionData: state.getIn(['dataBrowser', 'productionData']),
    environmentData: state.getIn(['dataBrowser', 'environmentData']),
  }),
  {
    setActiveDateRange,
  },
)(injectIntl(RightSidebar))
